import { Download } from "lucide-react";
import { cn } from "@/lib/utils";
import posthog from "@/lib/posthog";

const DEFAULT_DOWNLOAD_URL =
  "https://github.com/Converse-AI-Inc/Shadow/releases/latest/download/Shadow.dmg";

export default function DownloadAppButton({
  size = "md",
  className,
  withIcon = false,
  href = DEFAULT_DOWNLOAD_URL,
  onClick,
  location = "unknown",
  children = "Download App",
}) {
  const sizes = {
    sm: "h-9 px-4 text-sm",
    md: "h-11 px-5 text-sm",
    lg: "h-12 px-6 text-base",
  };

  return (
    <a
      href={href}
      onClick={(e) => {
        posthog.capture("landing.download_app.clicked", { location });
        onClick?.(e);
      }}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full",
        "bg-[#0092B4] text-white font-medium no-underline",
        "shadow-sm transition-all hover:bg-[#007a98] active:scale-[0.98]",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0092B4]/40 focus-visible:ring-offset-2",
        sizes[size],
        className
      )}
    >
      <span>{children}</span>
      {withIcon && (
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/20">
          <Download className="h-3.5 w-3.5" strokeWidth={2.5} />
        </span>
      )}
    </a>
  );
}
